import {ENUM_BASE, ENUM_IV} from "../../../../common/enums/index"
import Dialog from "../Dialog";
import CloseButton from "../CloseButton";
import Platform from "../../../platform";

// init enums
const AD_TYPE = ENUM_BASE.AD_TYPE
const IV_REWARD_MODE = ENUM_IV.IV_REWARD_MODE
const IV_REWARD_PLAY_VALUE_MODE = ENUM_IV.IV_REWARD_PLAY_VALUE_MODE
const IV_REWARD_PLAY_VALUE = ENUM_IV.IV_REWARD_PLAY_VALUE

// 用来标识用户是否曾经主动隐藏过关闭按钮（如：点击了 IV 弹窗中的 "继续"）
let videoCloseButtonHideByUser = false

class SingleVideoRewardManager {

    /**
     * 初始化 RV&IV 关闭按钮和弹窗奖励等业务逻辑
     * @param ad_type 广告类型：RV=94 IV=287
     * @param appSetting
     * @param unitSetting
     * @param videoElement 在 IV 下需要监听视频的播放进度，所以需要传递 video DOM 对象过来
     * @param currentCampaign 当前视频播放模板要展示的 campaign 素材对象
     * @param closeTplFunc 在逻辑走到最终需要关闭 "视频播放模板" 走后续跳转逻辑时，会触发这个回调
     * @param onDialogShow 展示弹窗时的回调
     * @param onDialogHide 隐藏弹窗时的回调
     */
    static init({ad_type, appSetting, unitSetting, videoElement, currentCampaign, closeTplFunc, onDialogShow, onDialogHide} = {}) {
        this.platform = Platform.getInstance()

        // TODO: mock data
        // Object.assign(unitSetting, {
        //     close_alert: 1,
        //     "endscreen_type": 2,
        //     "video_skip_time": 10,
        //     "video_skip_result": 2, // TODO endcard 跳转
        // })
        // Object.assign(appSetting, {
        //     ivreward: {
        //         ivRewardEnable: 1,
        //         ivRewardMode: 1, //CLOSE_MODE: 0, PLAY_MODE: 1,
        //         ivRewardPlayValueMode: 1, // ALERT_RATE: 0, // 0 ~ 1; ALERT_TIME: 1, // 0 ~ 100(s)
        //         ivRewardPlayValue: 10,
        //     }
        // })

        console.log('SVRM:  =======================', {
            ad_type,
            close_alert: unitSetting && unitSetting.close_alert,
            video_skip_time: unitSetting && unitSetting.video_skip_time,
            ivreward: appSetting && appSetting.ivreward,
            unitSetting,
            appSetting,
            videoElement,
            currentCampaign
        })

        // 初始化关闭按钮出现倒计时
        // 但这里暂时不能设置点击回调，需要根据 setting 在 RV IV 场景中，根据具体时机判断
        let videoCloseButton = this.initVideoCloseButton({unitSetting, videoElem: videoElement});

        // 初始化点击关闭按钮时，弹窗奖励等逻辑
        if (ad_type === AD_TYPE.RV) {
            console.log('SVRM:  ad_type: RV ', ad_type)
            // 如果 RV 设置启用了关闭提示，则在点击关闭按钮时出现弹窗
            if (this.isRVCloseAlertEnabled(unitSetting)) {
                console.log('RV 设置启用了关闭提示，则在点击关闭按钮时出现弹窗')
                this.initRVReward({appSetting, videoCloseButton, videoElement, closeTplFunc, onDialogShow, onDialogHide})
            } else {
                // 否则点击关闭按钮时不再出现弹窗
                console.warn('SVRM:  当前配置了不展示 RV 弹窗，点击关闭按钮时不再出弹窗')
                videoCloseButton.onClick(e => {
                    // TODO: 根据关闭的时间，处理 RV 奖励等相关业务
                    this.closeVideoTemplate({closeTplFunc});
                })
            }
        } else if (ad_type === AD_TYPE.IV) {
            console.log('SVRM:  ad_type: IV ', ad_type)
            // 如果 IV 设置启用了奖励弹窗，则走初始化弹窗逻辑
            if (this.isIVRewardEnabled()) {
                this.initIVReward({appSetting, videoCloseButton, videoElement, currentCampaign, closeTplFunc, onDialogShow, onDialogHide})
            } else {
                // 否则点击关闭按钮时直接走关闭回调，不再出现弹窗
                console.warn('SVRM:  当前配置了不展示 IV 弹窗，点击关闭按钮时不再出弹窗')
                videoCloseButton.onClick(e => {
                    // TODO: 根据关闭的时间，处理 IV 相关业务
                    this.closeVideoTemplate({closeTplFunc});
                })
            }
        } else {
            // TODO 如果检测到其他 ad_type，是否需要支持最基础的关闭/跳转ec？
            //  备注：目前不需要，必要的话可以通过额外埋点上报，先确定线上是否可能存在此场景
            console.error('SVRM:  当前指定的 ad_type 无效，请检查', ad_type, appSetting, unitSetting, videoElement)
        }
    }

    static initRVReward({appSetting, videoCloseButton, videoElement, closeTplFunc, onDialogShow, onDialogHide}) {
        // 初始化 rv dialog
        let {confirm_title, confirm_description, confirm_t, confirm_c_rv} = appSetting
        let RVDialog = new Dialog({
            title:confirm_title || '确认关闭？',
            content:confirm_description || '关闭后您将不会获得任何奖励',
            buttonGroup:[{
                size:"md",
                text: confirm_t || '确认关闭',
                onClick: (e) =>{
                    e.stopPropagation()
                    // init 传入的回调函数会根据业务需求：关闭视频模板并根据配置走跳转 ec 或其他业务
                    this.closeVideoTemplate({closeTplFunc});
                }
            }, {
                size:"md",
                text: confirm_c_rv || '继续观看',
                onClick: (e) => {
                    e.stopPropagation()
                    // 恢复视频播放
                    videoElement.play()
                    RVDialog.hide()
                    typeof onDialogHide === 'function' && onDialogHide()
                }
            }],
        })
        RVDialog.appendTo(document.querySelector('#container'));
        videoCloseButton.onClick(e => {
            if (videoElement.duration - videoElement.currentTime > 1) {
                videoElement.pause()
                RVDialog.show()
                typeof onDialogShow === 'function' && onDialogShow()
            }
        })
    }

    static initIVReward({appSetting, videoCloseButton, videoElement, currentCampaign, closeTplFunc, onDialogShow, onDialogHide}) {
        let ivreward = appSetting && appSetting.ivreward
        let ivRewardMode = ivreward && ivreward.ivRewardMode
        let ivRewardPlayValueMode = ivreward && ivreward.ivRewardPlayValueMode
        let ivRewardPlayValue = this.platform.getIvRewardPlayValue()

        // 初始化 IV 弹窗
        let IVDialog
        let {
            confirm_title = 'Continue?',
            confirm_description = 'If you continue, you can have reward when ad close.',
            confirm_t = 'Cancel',
            confirm_c_rv = 'Continue',
        } = appSetting
        let IVCloseModeDialogConfig = {
            title: confirm_title,
            content: confirm_description,
            buttonGroup: [{
                size:"md",
                text: confirm_t,
                onClick: (e) => {
                    e.stopPropagation()
                    this.closeVideoTemplate({closeTplFunc});
                }
            }, {
                size:"md",
                text: confirm_c_rv,
                onClick: (e) => {
                    e.stopPropagation()
                    // 恢复视频播放
                    videoElement.play()
                    // 隐藏弹窗
                    IVDialog.hide()
                    typeof onDialogHide === 'function' && onDialogHide()
                    // 隐藏关闭按钮
                    videoCloseButton.hide()
                    videoCloseButtonHideByUser = true
                }
            }]
        };
        let IVPlayModeDialogConfig = {
            title: confirm_title,
            content: confirm_description,
            buttonGroup: [{
                size:"md",
                text: confirm_t,
                onClick: (e) => {
                    e.stopPropagation()
                    // play mode 下点击取消只是隐藏弹窗，并不隐藏关闭按钮，也不关闭视频
                    // TODO 恢复视频播放
                    videoElement.play()
                    // 隐藏弹窗
                    IVDialog.hide()
                    typeof onDialogHide === 'function' && onDialogHide()
                }
            }, {
                size:"md",
                text: confirm_c_rv,
                onClick: (e) => {
                    e.stopPropagation()
                    // TODO 恢复视频播放
                    videoElement.play()
                    // 隐藏弹窗
                    IVDialog.hide()
                    typeof onDialogHide === 'function' && onDialogHide()
                    // 隐藏关闭按钮
                    videoCloseButton.hide()
                    videoCloseButtonHideByUser = true
                }
            }]
        };

        // 初始化 closeMode / playMode
        if (ivRewardMode === IV_REWARD_MODE.CLOSE_MODE) {
            console.log('SVRM:  CLOSE_MODE')
            IVDialog = new Dialog(IVCloseModeDialogConfig)
            IVDialog.appendTo(document.querySelector('#container'));
            switch (ivRewardPlayValueMode) {
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_RATE:
                    ivRewardPlayValue = this.autoFixUnsafeRateValue(ivRewardPlayValue);
                    console.log('SVRM:  ALERT_RATE', ivRewardPlayValue, currentCampaign.video_length)
                    // 点击关闭按钮时，如果达到指定的播放进度百分比，就直接关闭视频(TODO 是否需要回调开发者给奖励？)
                    videoCloseButton.onClick(e => {
                        if (videoElement.currentTime / currentCampaign.video_length >= ivRewardPlayValue) {
                            this.closeVideoTemplate({closeTplFunc});
                        } else if (videoElement.duration - videoElement.currentTime > 1) {
                            videoElement.pause()
                            IVDialog.show()
                            typeof onDialogShow === 'function' && onDialogShow()
                        }
                    })
                    break;
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_TIME:
                    ivRewardPlayValue = this.autoFixUnsafeTimeValue(ivRewardPlayValue);
                    console.log('SVRM:  ALERT_TIME', ivRewardPlayValue)
                    // 点击关闭按钮时，如果达到指定的播放时间，就直接关闭视频(TODO 是否需要回调开发者给奖励？)
                    videoCloseButton.onClick(e => {
                        if (videoElement.currentTime >= ivRewardPlayValue) {
                            this.closeVideoTemplate({closeTplFunc});
                        } else if (videoElement.duration - videoElement.currentTime > 1) {
                            videoElement.pause()
                            IVDialog.show()
                            typeof onDialogShow === 'function' && onDialogShow()
                        }
                    })
                    break;
                default:
                    console.warn('SVRM:  无法识别的 playMode，不再初始化后续逻辑')
                    break;
            }
        } else if (ivRewardMode === IV_REWARD_MODE.PLAY_MODE) {
            console.log('SVRM:  PLAY_MODE')
            IVDialog = new Dialog(IVPlayModeDialogConfig)

            // 设置关闭按钮点击回调
            videoCloseButton.onClick(e => {
                this.closeVideoTemplate({closeTplFunc});
            })

            let triggerTime, dialogHasNotShowOnce = true
            switch (ivRewardPlayValueMode) {
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_RATE:
                    ivRewardPlayValue = this.autoFixUnsafeRateValue(ivRewardPlayValue);
                    // 视频播放进度满足指定的百分比时，自动暂停视频并出现弹窗
                    triggerTime = currentCampaign.video_length * ivRewardPlayValue
                    console.log('SVRM:  ALERT_RATE', ivRewardPlayValue, triggerTime)
                    videoElement.addEventListener('timeupdate', e => {
                        if (dialogHasNotShowOnce && videoElement.currentTime >= triggerTime) {
                            dialogHasNotShowOnce = false
                            videoElement.pause()
                            IVDialog.show()
                            typeof onDialogShow === 'function' && onDialogShow()
                        }
                    })
                    break;
                case IV_REWARD_PLAY_VALUE_MODE.ALERT_TIME:
                    // 视频播放固定一段时间，自动暂停视频并出现弹窗
                    ivRewardPlayValue = this.autoFixUnsafeTimeValue(ivRewardPlayValue);
                    console.log('SVRM:  ALERT_TIME', ivRewardPlayValue)
                    triggerTime = ivRewardPlayValue
                    videoElement.addEventListener('timeupdate', e => {
                        if (dialogHasNotShowOnce && videoElement.currentTime >= triggerTime) {
                            dialogHasNotShowOnce = false
                            videoElement.pause()
                            IVDialog.show()
                            typeof onDialogShow === 'function' && onDialogShow()
                        }
                    })
                    break;
                default:
                    console.warn('SVRM:  无法识别的 playMode，不再初始化后续逻辑')
                    break;
            }
        } else {
            // PS：SDK ivRewardMode 只会返回 0/ 1, 兜底为 1，所以不需要考虑匹配不到的情况
            // console.warn('SVRM:  IV 没有匹配到 RewardMode，不再初始化后续逻辑', ivRewardMode)
        }
    }

    static autoFixUnsafeTimeValue(ivRewardPlayValue) {
        if (ivRewardPlayValue < 0) {
            ivRewardPlayValue = IV_REWARD_PLAY_VALUE.ALERT_TIME_DEFAULT
        }
        return ivRewardPlayValue;
    }

    static autoFixUnsafeRateValue(ivRewardPlayValue) {
        if (ivRewardPlayValue < 0) {
            ivRewardPlayValue = IV_REWARD_PLAY_VALUE.ALERT_RATE_DEFAULT
        }
        return ivRewardPlayValue;
    }

    /**
     *
     * @param closeTplFunc
     * @param IVDialog
     */
    static closeVideoTemplate({closeTplFunc} = {}) {
        if (typeof closeTplFunc === 'function') {
            closeTplFunc()
        } else {
            console.error('没有提供 RV 弹窗的关闭回调，请检查')
        }
    }

    static initVideoCloseButton({unitSetting, videoElem}) {
        // 初始化关闭按钮
        let videoCloseButton = new CloseButton()
        // 设置关闭按钮倒计时出现逻辑
        let video_skip_time = unitSetting && unitSetting.video_skip_time
        console.log(`SVRM:  ${video_skip_time} 秒后出现关闭按钮`)
        if (video_skip_time >= 0) {
            videoCloseButton.showByVideoPlayTime({
                countdown: video_skip_time,
                videoElem,
                callbackBeforeShow: () => {
                    // 如果用户主动隐藏了关闭按钮（如：通过点击 IV 弹窗中的 "继续"），则后续播放过程中不再展示关闭按钮
                    if (videoCloseButtonHideByUser) {
                        console.warn('SVRM:  请注意，用户之前主动隐藏了关闭按钮，所以倒计时结束时不再展示')
                        return false
                    } else {
                        return true
                    }
                }
            })
        } else {
            console.warn('SVRM:  当前 video_skip_time 配置了 -1 或其他无效值，视频播放期间不再展示关闭按钮')
        }

        return videoCloseButton
    }

    static isRVCloseAlertEnabled(unitSetting) {
        return unitSetting && unitSetting.close_alert === 1;
    }

    static isIVRewardEnabled() {
        let ivRewardEnable = this.platform.getIvRewardEnable();
        console.log('SVRM:  ivRewardEnable: ', ivRewardEnable)
        return ivRewardEnable === 1;
    }
}

export default SingleVideoRewardManager